import { render, staticRenderFns } from "./BaseTextInput.vue?vue&type=template&id=a2b8f338"
import script from "./BaseTextInput.vue?vue&type=script&lang=js"
export * from "./BaseTextInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports